var map = {
	"./en_criticalGoals.json": 693,
	"./es_criticalGoals.json": 7874,
	"./zh-hans_criticalGoals.json": 395
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	var id = map[req];
	return __webpack_require__.t(id, 3 | 16);
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9413;
module.exports = webpackAsyncContext;